import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { ROUTING_STORE } from 'store';
import { RouterStore } from 'mobx-react-router';
import styles from './SquareGradientButton.module.scss';
import { Icon } from 'components';

interface Statistic {
  key: string;
  value: number;
}

interface Props {
  colors: string[];
  title: string;
  label: string;
  icon: string;
  statistics?: Statistic[];
  path: string;
  [ROUTING_STORE]?: RouterStore;
}

class SquareGradientButton extends Component<Props> {
  handleOnClick() {
    const { path } = this.props;
    const { push } = this.props[ROUTING_STORE]!;

    push(path);
  }

  render() {
    const {
      title, label, icon,
      statistics, colors
    } = this.props;

    return (
      <div
        className={styles.container}
        onClick={this.handleOnClick.bind(this)}
      >
        <div
          className={styles.innerContainer}
          style={{
            background: `linear-gradient(to bottom, ${colors[0]} 0%, ${colors[1]} 100%)`
          }}>

          <div className={styles.titleContainer}>
            <Icon
              icon={icon}
              className={statistics ? styles.iconMargin : styles.icon}
            />
            <label>{label}</label>
            <h3>{title}</h3>
          </div>

          {statistics &&
            <div className={styles.statistics}>

              <div>
                <div>{statistics[0].value}</div>
                <div>{statistics[0].key}</div>
              </div>

              <div className={styles.verticalLine} />

              <div>
                <div>{statistics[1].value}</div>
                <div>{statistics[1].key}</div>
              </div>

            </div>
          }

        </div>
      </div>
    );
  }
}

export default inject(ROUTING_STORE)(SquareGradientButton);
